angular.module('dpw.components')
    .component('dpwDeveloperEvent', {
        templateUrl: 'dpw-developer-event.html',
        bindings: {
            event: '<',
            displayStartDate: '<?',
            pageName: '<'
        },
        controller: ['mixpanelService', function (mixpanelService) {
            this.mixpanelService = mixpanelService;
        }]
    });
